import React from 'react';

function Footer() {
  return (
    <footer>
      <div className="container-fluid footer-section">
        <div className="row">
          <div className="m-auto mt-2 text-center">
                      <img src="./img/logo_xsmall.png" alt="Company logo" />
          </div>
        </div>

        <div className="row m-4">
          <div className="m-auto font-weight-normal">
            &copy; 2020 All rights reserved
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer;
